export enum MfaErrors {
  REQUIRED = 'mfa-required',
  INVALID = 'mfa-invalid',
}

export enum MfaAuthMethods {
  EMAIL = 'email',
  SMS = 'sms',
}
